<form [formGroup]="form" (ngSubmit)="create()">
    <div class="card">
        <div class="card-header text-center" style="text-transform: uppercase;">CREAR INSTALACIÓN
        </div>
        <div class="card-body">
            <div class="row gx-3 mb-3">
                <div class="col-md-12">
                    <label class="small mb-1" for="name">Razón social / Nombre instalación (50 max.)</label>
                    <div class="input-group">
                        <input type="text" class="form-control text-capitalize" formControlName="name">
                    </div>
                </div>

                <div class="col-md-12">
                    <label class="small mb-1" for="rut">RUT</label>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
                        <input (keyup)="onFormatRut($event)" type="text" class="form-control" formControlName="rut">
                    </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="turn">Giro</label>
                    <input type="text" class="form-control" formControlName="turn">
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="location">Ubicación</label>
                    <input type="text" class="form-control" formControlName="location">
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="name">Propietario/Gerente (50 max.)</label>
                    <div class="input-group">
                        <input type="text" class="form-control text-capitalize" formControlName="owner">
                    </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="name">Telefono Propietario/Gerente</label>
                    <div class="input-group">
                        <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-phone"></i></span>
                        <input type="text" class="form-control text-capitalize" formControlName="owner_phone">
                    </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="email">Email</label>
                    <div class="input-group flex-nowrap">
                        <span class="input-group-text" id="addon-wrapping"><i class="fa-regular fa-envelope"></i></span>
                        <input type="email" class="form-control" placeholder="Email  contacto" formControlName="email">
                    </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="phone">Tel.</label>
                    <div class="input-group flex-nowrap">
                        <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-phone"></i></span>
                        <input type="email" class="form-control" placeholder="Telefono contacto"
                            formControlName="phone">
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <button class="btn btn-primary w-100" type="submit">GUARDAR
            </button>
        </div>
        </div>
</form>